import resourceConfig from '../config';

export default {
    resources: {
        [resourceConfig.name]: {
            name: 'ФИАС |||| ФИАС',
            fields: {
                id: 'ID',
                companyName: 'Компания',
                productGroup: 'Товарная группа',
                items: 'Адреса',
                fiasId: 'Fias Id',
                kpp: 'Kpp'
            },
        },
    },
};